(function ($, window) {
    let prodigy_product_subscription = {
        prodigy_personalization_input_element: '.prodigy-personalization__input-js',
        subscription_price: 0,
        subscription_id: '',
        add_to_cart_button_element: '.add-to-cart-js',
        is_one_time_order: true,
        product_default_info_price_element: '.product-default-info-price-js',
        is_show_subscription_popup: false,

        init: function () {
            this.set_subscription_id();
        },

        set_subscription_id: function () {
            this.subscription_id = $('.subscription_id').val();
        },

        format_subscription_price: function (price) {
            if (this.is_subscriptions()) {
                if (typeof parse_price(price) === 'undefined') {
                    price = $('.sale-subscription-price-js').text();
                }

                let sale_price = $('.subscription-sale_price-js').val();
                let one_time_price = $('.prodigy-subscriptions-tab__item-price').find('.sale-price').text();
                $('.subscriptions-price-currency-js').show();

                if (!prodigyProductBulk.is_active_bulk) {
                    if (parse_price(price) !== parse_price(sale_price)) {
                        $('.subscriptions-regular-price-js').text(prodigy_price_format(parse_price(price)));
                    }
                    $(this.product_default_info_price_element).text('$' + prodigy_price_format(parse_price(sale_price)));
                }
                $('.prodigy-subscriptions-tab-js').trigger('click');

                if (parseFloat(one_time_price) !== parseFloat(price)) {
                    $('.subscriptions-one-time-price-js').text('$' + prodigy_price_format(parse_price(price)));

                    let one_time_sale_price = $('.prodigy-product-list__item-price-js').text();
                    if (parse_price(one_time_sale_price) !== undefined) {
                        $('.subscriptions-one-time-price-js').text(one_time_sale_price);
                    }
                } else {
                    $('.subscriptions-one-time-price-js').parent().hide();
                }
            }
        },

        is_need_replace_subscription_item: function (subscription_id) {
            let self = this;
            let remote_product_id;
            let attribute_values_js = $('.attribute_values_js');

            // if isset variants
            if (attribute_values_js.length > 0) {
                remote_product_id = $(self.add_to_cart_button_element).attr('data-remote-id');
            } else {
                if (typeof prodigyProduct.remote_product !== 'undefined') {
                    remote_product_id = prodigyProduct.remote_product.remote_master_id_variant;
                }
            }

            if (typeof remote_product_id !== 'undefined') {
                let post_data = {
                    action: 'prodigy-is-replace-subscription-item',
                    remote_product_id: remote_product_id,
                    one_time_order: self.is_one_time_order,
                };

                if (!self.is_one_time_order && subscription_id && typeof subscription_id !== 'undefined') {
                    self.subscription_id = subscription_id;
                    post_data.subscription_id = subscription_id;
                }

                $.ajax(
                    {
                        type: 'post',
                        data: post_data,
                        dataType: 'json',
                        url: ajax_url,
                        success: function (data) {
                            if (data !== null) {
                                prodigyProduct.is_show_subscription_popup = data.show_subscription_popup;
                            }
                        },
                    },
                );
            }
        },

        show_subscription_block: function (is_selected_variant, subscriptions, price) {
            let default_info = $('.product-default-info-js');
            default_info.show();
            if (is_selected_variant) {
                default_info.hide();

                if (subscriptions) {
                    $('.prodigy-subscriptions-tab-js:first').trigger('click');
                    $('.prodigy-product__price-wrapper').hide();
                } else {
                    $('.prodigy-product__price-wrapper').show();
                }
                this.show_subscription_price(price);
            } else if (this.is_subscriptions()) {
                $(this.product_default_info_price_element).text('$' + price);
            }
        },

        show_subscription_price: function (price) {
            let sale_price = $('.subscription-sale_price-js').val();
            if (sale_price !== price && typeof sale_price !== 'undefined') {
                let price = prodigyProduct.get_current_product_price();
                let price_string = '$' + prodigy_price_format(price);
                $('.prodigy-product__prop-txt-price').text(price_string).show();
            }
        },

        is_subscriptions: function () {
            return $(document).find('.prodigy-subscriptions-tab').length > 0;
        },

        set_subscription_block: function (variant) {
            if (variant.subscriptions !== "") {
                $('#subscriptions_block').show();
                $('#subscriptions_block').html(variant.subscriptions);
            } else {
                $('#subscriptions_block').hide();
            }
        },

        set_subscriptions: function () {
            let self = this;
            let sale_price = 0;

            $(document).on('change', '.subscription-radio-js', function () {
                    if ($(this).is(':checked')) {
                        sale_price = $(this).prev().prev().prev().prev().val();
                        let sale_price_rounded = parseFloat(sale_price) < 0 ? 0 : parseFloat(sale_price);
                        self.subscription_price = sale_price;
                        $('.sale-subscription-price-js').text(prodigy_price_format(sale_price_rounded));
                        self.subscription_id = $(this).prev().prev().prev().val();
                        self.is_need_replace_subscription_item(self.subscription_id);
                        self.set_subscription_additional_price(sale_price, $(this));

                        let price = $('.regular-price').text();
                        if (price === '') {
                            price = prodigy_price_format(parse_price($('.sale-price').text()));
                        }

                        let price_container = $(this).closest('.prodigy-subscriptions-tab').find('.prodigy-subscriptions-tab__item-sale');
                        if (parse_price(self.subscription_price) !== parse_price(price)) {
                            price_container.show();
                            $('.subscriptions-regular-price-js').text(prodigy_price_format(parse_price(price))).show();
                        } else {
                            price_container.hide();
                        }
                    }
                },
            );

            $(document).on(
                'click',
                'button.prodigy-close-button, button.close-subscription-popup-js',
                function () {
                    $('#add_item_Modal').modal('hide');
                    prodigyProduct.is_show_subscription_popup = true;
                },
            );

            $(document).on(
                'click',
                '.prodigy-subscriptions-tab-js',
                function () {
                    self.set_subscription_options($(this));
                    self.activate_subscription_block($(this));
                    let is_conditions = $(this).next().find('.prodigy-subscription-period-js');

                    if (is_conditions.length > 0) {
                        $('.subscription-radio-js').each(
                            function () {
                                if ($(this).is(':checked')) {
                                    $('.subscription-radio-js').removeAttr('disabled');
                                    sale_price = parseFloat($('.sale-subscription-price-js').text().trim());
                                    self.subscription_price = parseFloat(sale_price) < 0 ? 0 : parseFloat(sale_price);
                                    self.subscription_id = $(this).prev().prev().prev().val();
                                    self.is_need_replace_subscription_item(self.subscription_id);
                                    self.set_subscription_additional_price(sale_price, $(this));
                                }
                            },
                        );
                    } else {
                        self.is_need_replace_subscription_item();
                        let price = $(this).next().find('.prodigy-subscriptions-tab__item-price').text();
                        $(self.product_default_info_price_element).text(price);
                    }
                },
            );
        },


        set_subscription_options: function (container) {
            let self = this;
            self.set_subscription_price(container);
            if (container.hasClass('active')) {
                if (container.attr('aria-controls') === 'nav-home') {
                    self.subscription_price = container.find('.sale-price').text().trim();
                    self.is_one_time_order = true;
                } else {
                    self.subscription_price = $('.sale-subscription-price-js').text().trim();
                    self.is_one_time_order = false;
                }
            }
        },

        load_subscription_price: function () {
            let self = this;
            $('.prodigy-subscriptions-tab-js').each(
                function () {
                    self.set_subscription_options($(this));
                },
            );
        },

        set_subscription_additional_price: function (price, container) {
            let format_price_string = '$' + prodigy_price_format(price);
            let condition_string = container.parent().find('.subscription-condition-js').val();
            $(this.product_default_info_price_element).text(format_price_string + ' (' + condition_string + ')');
        },

        activate_subscription_block: function (container) {
            $('.prodigy-subscriptions-radio-js').prop('checked', false);
            $('.prodigy-subscriptions-tab-js').removeClass('active');
            $(container).find('.prodigy-subscriptions-radio-js').prop('checked', true);
            container.addClass('active');
            $('.subscription-radio-js').prop(
                'disabled',
                function (i, v) {
                    return !v;
                },
            );
        },

        set_subscription_price: function (container) {
            let subscription_price = $('.prodigy-subscriptions-wrap-price-js').text();
            $('.prodigy-additional-info-price-js').text(subscription_price).show();
        },


    };
    window.prodigyProductSubscription = prodigy_product_subscription;
})(jQuery, window);

jQuery(document).ready(
    function ($) {
        window.prodigyProductSubscription.init();
    }
);